class BloomreachTrack extends HTMLElement {
  connectedCallback() {
    const eventName = this.dataset.eventName;
    if (!eventName) return;

    const triggerOn = this.dataset.triggerOn || 'view';
    const destination = this.dataset.destination || 'datalayer';
    const payload = this.#readPayload('bloomreach-track.event-data');
    const datalayerExtra = this.#readPayload('bloomreach-track.datalayer-data');

    if (triggerOn === 'click') {
      const trigger = this.querySelector('[data-bloomreach-track-trigger]') || this.firstElementChild;
      if (trigger) {
        trigger.addEventListener('click', () => this.#dispatch(destination, eventName, payload, datalayerExtra));
      }
      return;
    }

    this.#dispatch(destination, eventName, payload, datalayerExtra);
  }

  #readPayload(target) {
    const dataScript = this.querySelector(`script[data-target="${target}"]`);
    if (!dataScript) return {};
    try {
      return JSON.parse(dataScript.textContent);
    } catch {
      return {};
    }
  }

  #dispatch(destination, eventName, payload, datalayerExtra) {
    if (destination === 'exponea' || destination === 'both') {
      this.#track(eventName, payload);
    }
    if (destination === 'datalayer' || destination === 'both') {
      this.#push(eventName, payload, datalayerExtra);
    }
  }

  #track(eventName, payload) {
    const sdk = window.exponea || window.brweb;
    if (!sdk || typeof sdk.track !== 'function') return;
    try {
      sdk.track(eventName, payload);
    } catch {
      /* no-op */
    }
  }

  #push(eventName, payload, datalayerExtra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload,
      ...datalayerExtra,
      page_title: document.title,
      location: window.location.href,
      referrer: document.referrer,
      timestamp: Math.floor(Date.now() / 1000),
    });
  }
}

customElements.define('bloomreach-track', BloomreachTrack);
